<div>
  <button
    pButton
    pRipple
    class="p-ml-3"
    icon="pi pi-times"
    label="{{ generalTexts.rejectBtn.label }}"
    (click)="toggleCommentDialog()"
  ></button>
  <button
    pButton
    pRipple
    icon="pi pi-check"
    class="p-ml-3"
    label="{{ generalTexts.approveBtn.label }}"
    (click)="toggleCommentDialog(true)"
  ></button>
</div>

<p-dialog
  header="{{ generalTexts.txtComment.label }}"
  [(visible)]="commentDialogVisible"
  [style]="{ width: '450px' }"
>
  <div class="p-fluid">
    <div class="p-col-12">
      <textarea
        [(ngModel)]="comment"
        pInputTextarea
        rows="5"
        name="comment"
      ></textarea>
    </div>
    <div class="p-col-12">
      <div class="p-d-inline-block">
        <button
          pButton
          type="button"
          (click)="saveWorkflowActivity()"
          [label]="generalTexts.btnSubmit.label"
          [disabled]="!comment || submitted"
        ></button>
      </div>
      <div class="p-d-inline-block p-ml-2">
        <button
          pButton
          type="button"
          (click)="toggleCommentDialog()"
          [label]="generalTexts.btnCancel.label"
        ></button>
      </div>
    </div>
  </div>
</p-dialog>
